<template>
  <div>
    <div :class="['off-canvas-menu', isActive ? 'active' : '']">
      <div :class="['close-menu', isActive ? 'active' : '']" @click="closeMenu()">
        <a href="#"><i class="fas fa-times"></i></a>
      </div>
      <ul>
        <li v-for="(item, i) in menuItems" :key="'main' + i">
          <a
            v-if="item.subMenuItem.length > 0"
            data-toggle="collapse"
            :href="'#collapseExamplec' + i"
            role="button"
            aria-expanded="false"
            :aria-controls="'#collapseExamplec' + i"
            >{{ item.title }}<i class="fal fa-chevron-up"></i><i class="fal fa-chevron-down"></i
          ></a>
          <router-link v-else :to="item.link ? item.link : '#'" v-on:click.native="closeMenu()">{{
            item.title
          }}</router-link>
          <ul class="collapse" v-if="item.subMenuItem.length > 0" :id="'collapseExamplec' + i">
            <li v-for="(subItem, l) in item.subMenuItem" :key="'sub' + i + l">
              <router-link :to="subItem.link" v-on:click.native="closeMenu()">{{
                subItem.title
              }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="off-canvas-overlay" @click="closeMenu()"></div>
    <!-- Header bar section start -->
    <div class="header-area internet">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="header-logo">
              <router-link to="/"><img src="assets/img/internet-logo.png" alt=""/></router-link>
              <div class="header-off-btn menu-trigger right">
                <a href="#" @click="revealMenu()"><i class="fas fa-align-right"></i></a>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="header-main-menu">
              <div class="mainmenu">
                <ul>
                  <li v-for="(item, i) in menuItems" :key="'main' + i">
                    <router-link :to="item.link ? item.link : '#'">{{ item.title }}</router-link>
                    <ul class="submenu" v-if="item.subMenuItem.length > 0">
                      <li v-for="(subItem, l) in item.subMenuItem" :key="'sub' + i + l">
                        <router-link :to="subItem.link">{{ subItem.title }}</router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="search-containt dropdown show">
                <a href="#" v-if="searchMenu"><i class="fas fa-search"></i></a>
                <language-selector v-if="langMenu"></language-selector>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Header bar section complate -->
  </div>
</template>

<script>
import LanguageSelector from '@/components/common/LanguageSelector';
import { loadMenu } from '@/api/navItems';
import NavUtils from '@/mixins/NavUtils';

export default {
  data() {
    return {
      menuItems: [],
      langs: [],
      defaultLang: {},
      isActive: false,
      searchMenu: false,
      langMenu: false
    };
  },
  mixins: [NavUtils],
  components: {
    LanguageSelector
  },
  async created() {
    let menu = await loadMenu('top', this.$store.state.language.iso_code);
    this.menuItems = menu[0]['menuItem'];
    this.$root.$on('update-language', val => {
      this.updateMenu('top', val);
    });
  },
  methods: {
    revealMenu() {
      this.isActive = true;
    },
    closeMenu() {
      this.isActive = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
